import Phaser from "phaser";
import Pqp from "../../3x1010/Pqp";
import MainScene from "./MainScene";
import ProgressBar from "./ProgressBar";
import Tracking from "./Tracking";

export default class PanelReport extends Phaser.GameObjects.Container {
  constructor(scene, callback) {
    super(scene);
    this.clips = [];
    this.callback = callback;
    this.rexUI = this.scene.rexUI;
  }

  init() {
    const background = this.scene.add.image(0, 0, "fieldReport");
    background.setOrigin(0, 0);
    this.add(background);
    //background.width = Tracking.WIDTH;
    //background.height = Tracking.HEIGHT;
    this.width = background.width;
    this.height = background.height;
    background.setBlendMode(Phaser.BlendModes.MULTIPLY);
    background.setInteractive();

    // Il titoletto
    const type = MainScene.that.dataSelected.report.current.strokeType;
    let desc = "|  REPORT  |";
    if (type === "serve") {
      desc = "|  LE FASI DEL SERVIZIO  |";
    } else if (type === "forehand") {
      desc = "|  LE FASI DEL COLPO DRITTO  |";
    } else if (type === "backhand") {
      desc = "|  LE FASI DEL RIVESCIO  |";
    }

    const txt = this.scene.add.text(0, 0, desc, { fontFamily: "DIN Next LT Pro", fontSize: "40px", color: this.toHexColor(ProgressBar.COLOR_BACK), align: "center", fixedWidth: this.width });
    this.add(txt);
    txt.y = 32;
    this.txt = txt;

    this.initScrollablePanel();
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      if (!Pqp.isNullOrEmpty(data)) {
        e.data = data;
      }
      this.callback.call(null, e);
    }
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }

  initScrollablePanel() {
    const config = {
      //x: 98,
      //y: 98,
      x: Math.floor((Tracking.WIDTH - PanelReport.WIDTH) / 2),
      y: 120,
      width: PanelReport.WIDTH,
      height: 700,

      scrollMode: 0,

      //background: this.rexUI.add.roundRectangle(0, 0, 2, 2, 10, 0x333333),

      panel: {
        child: this.createGrid(this.scene),
        mask: {
          mask: true,
          padding: 1,
        },
      },

      slider: {
        track: this.rexUI.add.roundRectangle(0, 0, 10, 10, 1, 0x162ca1),
        thumb: this.rexUI.add.roundRectangle(0, 0, 0, 0, 5, 0xffffff),
      },

      mouseWheelScroller: {
        focus: true,
        speed: 0.25,
      },
    };

    this.scrollablePanel = this.rexUI.add.scrollablePanel(config).layout();
    this.scrollablePanel.setOrigin(0, 0);
    this.scrollablePanel.layout();
    this.scrollablePanel.setDepth(1000000);
    this.scrollablePanel.visible = false;
    //this.add(this.scrollablePanel);
  }

  showScrollablePanel(lFlag) {
    this.scrollablePanel.setDepth(MainScene.ZINDEX);
    MainScene.ZINDEX++;
    this.scrollablePanel.visible = lFlag;
  }

  createGrid(scene) {
    const a = MainScene.that.dataSelected.report.current;
    const sizer = scene.rexUI.add.fixWidthSizer();
    let posy = 0;
    const span0 = "        ";

    for (let x = 0; x < a.length; x++) {
      const entry = a[x];

      if (entry.hasErrors) {
        const txt = this.scene.add.text(40, 0, "❌" + entry.fase.toUpperCase(), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: PanelReport.WIDTH - 40 });
        sizer.add(txt);
        this.addSeparator(sizer);

        const indicators = entry.indicators;
        let presi = 0;
        for (let y = 0; y < indicators.length; y++) {
          if (indicators[y].hasErrors) {
            posy += 80;
            const txt = this.scene.add.text(0, 0, indicators[y].meta.name + this.writeErrors(indicators[y]), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: PanelReport.WIDTH - 40 - 64 });
            sizer.add(txt, { padding: { left: 64 } });
            sizer.addNewLine();
            const desc = this.scene.add.text(0, 0, indicators[y].meta.desc, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: 1240 - 64, wordWrap: { width: PanelReport.WIDTH - 40 - 64, useAdvancedWrap: true } });
            sizer.add(desc, { padding: { left: 96 } });
            sizer.addNewLine();
            if (!Pqp.isNullOrEmpty(indicators[y].mediaErrore)) {
              const media = this.scene.add.text(0, 0, "Media errore: " + indicators[y].mediaErrore, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: "#ff2400", fixedWidth: PanelReport.WIDTH - 40 - 64 });
              sizer.add(media, { padding: { left: 96 } });
              sizer.addNewLine();
            }
            if (indicators[y].deviazioneStandard !== 0) {
              const dev = this.scene.add.text(0, 0, "Deviazione standard errore: " + indicators[y].deviazioneStandard, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: "#ff2400", fixedWidth: PanelReport.WIDTH - 40 - 64 });
              sizer.add(dev, { padding: { left: 96 } });
              sizer.addNewLine();
            }
            if (indicators[y].meta.solution) {
              const solution = this.scene.add.text(0, 0, indicators[y].meta.solution, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: "#00FF00", fixedWidth: 1240 - 64, wordWrap: { width: PanelReport.WIDTH - 40 - 64, useAdvancedWrap: true } });
              sizer.add(solution, { padding: { left: 96 } });
              sizer.addNewLine();
            }

            this.addSeparator(sizer);
            presi++;
            if (presi === 3) {
              break;
            }
          }
        }
      } else {
        const txt = this.scene.add.text(40, 0, "✔️" + entry.fase.toUpperCase(), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: PanelReport.WIDTH - 40 });
        sizer.add(txt);
      }
      this.addSeparator(sizer);
    }
    sizer.addNewLine();
    sizer.layout();

    this.mysizer = sizer;
    return sizer;
  }

  writeErrors(ind) {
    let ret = "";
    if (ind.errors === 1) {
      ret = " (1 errore)";
    } else {
      ret = " (" + ind.errors + " errori)";
    }
    return ret;
  }

  addSeparator(sizer) {
    const txt = this.scene.add.text(0, 0, " ", { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: 1240 });
    sizer.add(txt);
  }

  createGrid1(scene) {
    const a = MainScene.that.dataSelected.report.current;
    const sizer = scene.rexUI.add.fixWidthSizer();
    let posy = 0;
    const container = scene.add.container(0, 0);
    for (let x = 0; x < a.length; x++) {
      const entry = a[x];

      if (entry.hasErrors) {
        const img = this.scene.add.image(0, 0, "ko");
        img.y = posy;
        img.setOrigin(0, 0);
        container.add(img);

        const txt = this.scene.add.text(40, 0, entry.fase.toUpperCase(), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: 1240 });
        txt.x = 64;
        container.add(txt);
        txt.y = posy;

        const indicators = entry.indicators;
        for (let y = 0; y < indicators.length; y++) {
          if (indicators[y].hasErrors) {
            posy += 80;
            const txt = this.scene.add.text(0, 0, indicators[y].meta.name, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: 1240 });
            container.add(txt);
            txt.x = 64;
            txt.y = posy;
            posy += 40;

            const desc = this.scene.add.text(0, 0, indicators[y].meta.desc, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: 1240, wordWrap: { width: 1240, useAdvancedWrap: true } });
            container.add(desc);
            desc.x = 64;
            desc.y = posy;
            posy += desc.height + 8;
          }
        }
        if (indicators.length === 0) {
          posy += 40;
        }
      } else {
        const img = this.scene.add.image(0, 0, "ok");
        img.setOrigin(0, 0);
        img.y = posy;
        container.add(img);

        const txt = this.scene.add.text(40, 0, entry.fase.toUpperCase(), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_BACK), fixedWidth: 1240 });
        txt.x = 64;
        txt.y = posy;
        container.add(txt);
      }
      posy += 80;
    }
    sizer.add(container);
    sizer.addNewLine();
    sizer.layout();

    this.mysizer = sizer;
    return sizer;
  }
}

PanelReport.WIDTH = 1000;
